import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const SIGNUP_TICKET_KEY = "signup_ticket";

/**
 * signupTicket 은 access token 이 아니다.
 * SNS 로그인 미가입 분기(`nextType: "signup_required"`)에서 발급받아
 * credit4u 가입 흐름에 전달하는 회원가입 전용 JWT (20분 TTL).
 *
 * - Authorization: Bearer 로 사용 금지 (서버가 purpose 검증으로 거부).
 * - hasToken / getToken / refresh 대상이 아니므로
 *   shared/auth/tokenStorage 가 아닌 feature-local store 에 분리 저장한다.
 * - 탭 종료 시 폐기되도록 sessionStorage 로 persist.
 */
type SignupTicketState = {
  signupTicket: string | null;
  setSignupTicket: (ticket: string) => void;
  clearSignupTicket: () => void;
};

export const useSignupTicketStore = create<SignupTicketState>()(
  persist(
    (set) => ({
      signupTicket: null,
      setSignupTicket: (ticket) => set({ signupTicket: ticket }),
      clearSignupTicket: () => set({ signupTicket: null }),
    }),
    {
      name: SIGNUP_TICKET_KEY,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

/**
 * React hook 컨텍스트 없이 콜백/유틸 내부에서 직접 호출할 수 있는 단독 함수.
 * window.sns_login 콜백, credit4u flow hook 등에서 사용한다.
 */
export const getSignupTicket = (): string | null =>
  useSignupTicketStore.getState().signupTicket;

export const setSignupTicket = (ticket: string): void =>
  useSignupTicketStore.getState().setSignupTicket(ticket);

export const clearSignupTicket = (): void =>
  useSignupTicketStore.getState().clearSignupTicket();
